import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getFunctions } from "firebase/functions"; 

function resolveEnvironment() {
  const configured = process.env.VUE_APP_ENVIRONMENT;
  if (configured === "stg" || configured === "prd") {
    return configured;
  }

  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (host.includes("-stg.") || host.includes("stg")) {
      return "stg";
    }
    if (host.includes("due.app.br")) {
      return "prd";
    }
  }

  throw new Error(`Unknown environment: ${configured}`);
}

const environment = resolveEnvironment();

let firebaseConfig;
if (environment === "stg") {
  firebaseConfig = require('./stg/firebaseConfig').firebaseConfig;
} else if (environment === "prd") {
  firebaseConfig = require('./prd/firebaseConfig').firebaseConfig;
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'southamerica-east1');

export { db, auth, storage, functions  };
